import { Box, useMediaQuery, useTheme } from '@mui/material';
import LogoLightSrc from '../../../../../assets/flexeserve_show_logo_light.svg';
import LogoDarkSrc from '../../../../../assets/flexeserve_show_logo_dark.svg';

function HeaderLogoFlexeserveExhibitions() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logoSrc = theme.palette.mode === 'dark' ? LogoDarkSrc : LogoLightSrc;
  return (
    <Box
      component={'img'}
      src={logoSrc}
      alt="Flexeserve Exhibitions Logo"
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        height: '2.5rem',
        maxWidth: 'auto',
        color: theme.palette.text.primary,
      })}
    />
  );
}

export default HeaderLogoFlexeserveExhibitions;
